import getFeature from "@src/template/helpers/getFeature";

const getFeatureVariables = async featureName => {
  const feature = await getFeature(featureName);

  return feature?.getVariables() || {};
};

export default getFeatureVariables;
